/* eslint-disable react/no-unknown-property */
import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="73" height="73" viewBox="0 0 73 73" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="73" height="73" rx="36.5" fill="#C6FFDD" />
    <rect
      width="73"
      height="73"
      rx="36.5"
      fill="url(#paint0_linear_18335_53439)"
      fillOpacity="0.5"
    />
    <path d="M19 34.625L31.5876 47L56 23" stroke="#01C44F" strokeWidth="7" />
    <defs>
      <linearGradient
        id="paint0_linear_18335_53439"
        x1="72.5494"
        y1="71.3805"
        x2="50.0529"
        y2="26.383"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#01C34F" />
        <stop offset="1" stop-color="#01C34F" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

const SuccessTick = (props) => <Icon component={svg} {...props} />;

export default SuccessTick;
